import React, { useEffect, useMemo, useState } from 'react'
import cookie from 'react-cookies'
import { getDDCodeLoginRequestDomain, getFeishuAppId } from '../utils'

const FEISHU_AUTH_DOMAIN = 'https://passport.feishu.cn'
const FEISHU_SCAN_TYPE = 'FeiShuScanCode'

const CodeLoginFs = (props) => {
    const { jumpUrl, iPV4, appid, networkIP, requestId } = props
    const [loadError, setLoadError] = useState('')
    const feishuAppId = getFeishuAppId()

    const redirectUrl = useMemo(() => {
        const loginDomain = getDDCodeLoginRequestDomain('')
        return `${loginDomain}/api/CodeLogin/ScanCodeLogin?type=${FEISHU_SCAN_TYPE}&url=${jumpUrl || ''}&ip=${iPV4 || ''}&appId=${appid || ''}&ati=${cookie.load('_ati') || ''}&netWorkIP=${networkIP || ''}&clientIp=${iPV4 || ''}&requestCid=${requestId || ''}`
    }, [jumpUrl, iPV4, appid, networkIP, requestId])

    const goto = useMemo(() => {
        if (!feishuAppId) return ''
        return `${FEISHU_AUTH_DOMAIN}/suite/passport/oauth/authorize?client_id=${feishuAppId}&redirect_uri=${encodeURIComponent(redirectUrl)}&response_type=code&state=STATE`
    }, [feishuAppId, redirectUrl])

    console.log("Feishu redirectUrl:" + redirectUrl);
    console.log("Feishugoto:" + goto);

    useEffect(() => {
        if (!feishuAppId) {
            setLoadError('请先配置飞书应用 App ID')
            return undefined
        }

        let mounted = true
        var QRLoginObj
        setLoadError('')

        if (!window.QRLogin) {
            setLoadError('飞书二维码 SDK 未加载')
            return undefined
        }

        try {
            const container = document.getElementById('fs_code_container')
            if (container) container.innerHTML = ''

            QRLoginObj = window.QRLogin({
                id: 'fs_code_container',
                goto,
                width: '360',
                height: '300',
                style: 'border:none;background-color:#FFF;'
            })
        } catch (error) {
            if (mounted) setLoadError('飞书二维码组件加载失败')
        }

        var handleMessage = function (event) {         
            // 使用 matchOrigin 和 matchData 方法来判断 message 和来自的页面 url 是否合法
            if(QRLoginObj.matchOrigin(event.origin) && QRLoginObj.matchData(event.data)) { 
                var loginTmpCode = event.data.tmp_code; 
                // 在授权页面地址上拼接上参数 tmp_code，并跳转
                window.location.href = `${goto}&tmp_code=${loginTmpCode}`;
            }
        };
        if (typeof window.addEventListener != 'undefined') {   
            window.addEventListener('message', handleMessage, false);} 
        else if (typeof window.attachEvent != 'undefined') { 
            window.attachEvent('onmessage', handleMessage);
        }
    }, [feishuAppId, goto])

    return (
        <div className='fs-code-login'>
            <div id='fs_code_container'></div>
            {loadError ? <div className='fs-code-error'>{loadError}</div> : null}
        </div>
    )
}

export default CodeLoginFs
